export default __webpack_public_path__ + "static/media/TRAIN TAB.f941469a.svg";